<template>
    <th :colspan="colspan">
        Total: {{ money(total) }}
    </th>
</template>

<script>
export default {
    props: [
        'rows',
        'dir',
        'colspan'
    ],
    computed: {
        total() {
            return _.sum(_.map(this.rows, (row) => {
                return !row[this.dir] || row[this.dir].is_deleted
                    ? 0.00
                    : (parseFloat(row[this.dir].singlecarrier.budget) + parseFloat(row[this.dir].multicarrier.budget));
            }));
        },
    },
    data() {
        return {}
    }
}
</script>

<style>
</style>
